import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { CardBody, Card, Row, Col } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import ModalTemplatePdf from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/ModalTemplatePDF';
import GeneratePDFReportServices from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/GeneratePDFReportServices';
import CloseIcon from '@material-ui/icons/Close';
import { Modal } from '@material-ui/core';
import { formatNumber } from '../../Utils/Money';


const ShowSettlementCard = ({ settlement }) => {
    const { value, data: invoicesInSettlement } = settlement;
    const [openSettlementPdf, setOpenSettlementPdf] = useState(false);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        setDetails(calculatePaymentsDetails(invoicesInSettlement.radicado));
    }, [])

    const getDataToPrint = (data, fechaInicial, fechaFinal, fechaRadicacion, contrato) => {
        setOpenSettlementPdf(true);
        let paymentsDetails = calculatePaymentsDetails(data);
        console.log("DATOS", data);
        console.log("fechaRadicacion", fechaRadicacion)
        GeneratePDFReportServices(data, paymentsDetails, fechaInicial, fechaFinal, fechaRadicacion, contrato);

    }

    const calculatePaymentsDetails = (data) => {
        let details = {
            valor_servicio_item: 0,
            valor_copago_item: 0,
            valor_neto_item: 0,
            cant_fact: 0
        }
        for (let i = 0; i < data.length; i++) {
            details.valor_servicio_item = parseInt(details.valor_servicio_item) + parseInt(data[i].valor_servicio_item);
            details.valor_copago_item = parseInt(details.valor_copago_item) + parseInt(data[i].valor_copago_item);
            details.valor_neto_item = parseInt(details.valor_neto_item) + parseInt(data[i].valor_neto_item);
            details.cant_fact = i + 1;
        }
        return details;
    }

    return (
        <Fragment>
            <Card>
                <CardBody style={{ padding: 0 }}>
                    <Row style={{ justifyContent: 'center' }}>
                        <div className='card-settlement'>
                            <div className='card-body-content info-description'>
                                {value &&
                                    <Fragment>
                                        <div className='card-value-info'>
                                            <p>La Factura Nro.: <b>{value.prefijo + '-' + value.consecutivo}</b></p>
                                            <p>se encuentra radicada en el</p>
                                        </div>
                                    </Fragment>
                                }
                                <div>
                                    <h3><b>RADICADO No. {settlement.id_radicado}</b></h3>
                                </div>
                                <div className='card-settlement-info-top'>
                                    <div>
                                        <h5><b>Fecha Emisión: </b>{moment(settlement.fecha_radicado).format('DD/MM/YYYY')}</h5>
                                    </div>
                                    {settlement.fecha_cierre !== null && settlement.fecha_cierre !== undefined ?
                                        <Fragment>
                                            <div>
                                                <p><b>Fecha radicación: </b>{moment(settlement.fecha_cierre).format('DD/MM/YYYY')}</p>
                                            </div>
                                            <div>
                                                <p><b>Observación: </b>{settlement.observacion_cierre}</p>
                                            </div>
                                        </Fragment>

                                        : null
                                    }
                                </div>
                            </div>
                            {
                                invoicesInSettlement.radicado.lenght !== 0 ?
                                    <Fragment>
                                        <div className='v-line-third-card-settlement'>
                                            <hr></hr>
                                        </div>
                                        <div className='card-settlement-values'>
                                            <div>
                                                <h4>Valor Facturado: <b style={{ color: '#0084CF' }}>${formatNumber(details?.valor_servicio_item)}</b></h4>
                                            </div>
                                            <div>
                                                <h4>Abonos: <b style={{ color: '#0084CF' }}>${formatNumber(details?.valor_copago_item)}</b></h4>
                                            </div>
                                            <div>
                                                <h4>Valor a Cobrar: <b style={{ color: '#0084CF' }}>${formatNumber(details?.valor_neto_item)}</b></h4>
                                            </div>
                                        </div>
                                        <div className='v-line-third-card-settlement'>
                                            <hr></hr>
                                        </div>
                                        <div className='card-settlement-other-invoices-part'>
                                            <div><p>Facturas en este radicado: <b>{details?.cant_fact}</b></p></div>
                                            <div className='card-settlement-other-invoices'>
                                                {invoicesInSettlement.radicado.map((invoice) => (
                                                    <div className='card-one-invoice' key={invoice.consecutivo}><h5><b>{invoice.prefijo + '-' + invoice.consecutivo}</b></h5></div>
                                                ))}
                                            </div>
                                            <div style={{ alignSelf: 'flex-end', margin: '0.5em 0em' }}>
                                                <Tooltip
                                                    title="Imprimir Radicado"
                                                    className='card-tooltip-settlement'
                                                >
                                                    <IconButton
                                                        aria-label="upload picture"
                                                        component="span"
                                                        onClick={() => {
                                                            // setEditThird(true);
                                                            getDataToPrint(invoicesInSettlement.radicado, settlement.fecha_inicio, settlement.fecha_final, settlement.fecha_radicado)
                                                        }}
                                                    >
                                                        <FontAwesomeIcon className='contact-icon-settlement' icon={faFilePdf} style={{ width: '0.5em' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </Fragment>
                                    : null
                            }
                        </div>
                    </Row>
                </CardBody>
            </Card>
            {openSettlementPdf ?
                <Modal
                    open={openSettlementPdf}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%'}}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setOpenSettlementPdf(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
            {/*  <ModalTemplatePdf openModal={openSettlementPdf} closeModal={() => setOpenSettlementPdf(false)} /> */}
        </Fragment>
    )
}

export default ShowSettlementCard